import { useTablaSolicitudes } from "./useTablaSolicitudes";
import { ModalContractualesAdmin } from "../modalForm/modalForm2";
import Datatable from "../../components/ui/datatable/Datatable";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faXmarkCircle } from "@fortawesome/free-solid-svg-icons";

export const TablaSolicitudes = () => {
  const {
    fetchTableData,
    columnsDef,
    selectedRows,
    setSelectedRows,
    handleAprobarGrupo,
    handleRechazarGrupo,
    objModalAdmin,
    visible,
    hideModal,
    refreshToggle,
    idPerfil,
  } = useTablaSolicitudes();

  return (
    <>
      <ModalContractualesAdmin data={objModalAdmin} show={visible} hideModal={hideModal} tamanio="xl" />
      <div className="container-fluid py-4" style={{ padding: "20px", marginTop: "-20px" }}>
        <Datatable
          refreshToggle={refreshToggle}
          storageKey="test-solicitudes-table"
          titletable="Solicitudes en curso"
          requestDataFn={fetchTableData}
          initialPerPage={10}
          columns={columnsDef}
          orderColumns={!["2", "3"].includes(idPerfil)}
          adjustColumnSize={true}
          searchEnabled={!["2", "3"].includes(idPerfil)}
          searchColumnsEnabled={!["2", "3"].includes(idPerfil)}
          columnSelectorEnabled={!["2", "3"].includes(idPerfil)}
          checkboxColumn={idPerfil === "2"}
          rowIdField="id"
          manualPageInput={false}
          rowsPerPageOptions={[10, 15, 20, 25, 30]}
          initialSortBy="fecha_inicio_cambio"
          initialSortDir="desc"
          onSelectionChange={setSelectedRows}
        />

        {idPerfil === "2" && selectedRows.length > 0 && (
          <div className="d-flex flex-column align-items-start mt-3 gap-2">
            <div className="d-flex align-items-center gap-2">
              <span
                className="badge rounded-pill px-3 py-2 fs-6 fw-bold"
                style={{ backgroundColor: "#2a77b9", color: "#ffffff" }}
              >
                {selectedRows.length}
              </span>
              <span className="fw-semibold text-secondary fs-6">
                {selectedRows.length === 1
                  ? "solicitud seleccionada"
                  : "solicitudes seleccionadas"}
              </span>
            </div>
            <div className="d-flex gap-3 align-items-center">
              <button
                type="button"
                className="btn btn-success px-4 py-2 fw-bold rounded-pill d-flex align-items-center gap-2"
                onClick={handleAprobarGrupo}
                style={{ border: "none" }}
              >
                <span>Aprobar</span>
                <FontAwesomeIcon icon={faCheckCircle} />
              </button>
              <button
                type="button"
                className="btn btn-danger px-4 py-2 fw-bold rounded-pill d-flex align-items-center gap-2"
                onClick={handleRechazarGrupo}
                style={{ border: "none" }}
              >
                <span>Rechazar</span>
                <FontAwesomeIcon icon={faXmarkCircle} />
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
